import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadRounded from '@mui/icons-material/CloudUploadRounded';

export interface FileDropOverlayProps {
  /** Show it: files are being dragged over the drop area. */
  active: boolean;
  /** What can be dropped, e.g. "CSV, Excel or PDF, up to 20 MB". */
  hint?: string;
}

/**
 * The "drop files to attach" layer over an area that takes files. Sits on top
 * of its parent (which must be `position: relative`) and lets pointer events
 * through, so the drop still lands on the parent.
 */
export function FileDropOverlay({ active, hint }: FileDropOverlayProps) {
  if (!active) return null;
  return (
    <Box
      aria-hidden
      sx={(t) => ({
        position: 'absolute',
        inset: t.spacing(1.5),
        zIndex: 2,
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 3,
        textAlign: 'center',
        borderRadius: `${t.ds.radius.lg}px`,
        border: `2px dashed ${t.tokens.brand.primary}`,
        bgcolor: t.tokens.brand.primarySofter,
        backdropFilter: 'blur(3px)',
      })}
    >
      <CloudUploadRounded fontSize="large" sx={(t) => ({ color: t.tokens.text.accent })} />
      <Typography variant="h6" component="p" sx={(t) => ({ m: 0, color: t.tokens.text.accent })}>
        Drop files to attach
      </Typography>
      {hint && (
        <Typography variant="body2" sx={(t) => ({ color: t.tokens.text.secondary, maxWidth: '44ch' })}>
          {hint}
        </Typography>
      )}
    </Box>
  );
}
